"use strict";

exports.__esModule = true;
exports.StripeChartWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _EditableStripeChartElement = require("./EditableStripeChartElement");
var _StripeChartElement = require("./StripeChartElement");
var _StripeChartFields = require("./StripeChartFields");
var _StripeChartHeader = require("./StripeChartHeader");
var _StripeChartThumbnail = require("./StripeChartThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StripeChartWidget = exports.StripeChartWidget = {
  name: "StripeChart",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "StripeChartWidget.label",
    defaultMessage: "Stripe Chart"
  }),
  icon: "timeline-area-chart",
  group: _widgetGroups.TIMELINE_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "StripeChart",
      props: Object.assign({
        width: 200,
        height: 150,
        showAlerts: true,
        showTickets: true,
        showComments: true,
        showDivision: false,
        showLabel: true
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["hideXAxis", "timeline", "dataRange", "brushEnableDragging", "brushEnableResize", "brushEnableSnapToTimeline", "brushEnableSnapToSelection"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 200,
      min: 64,
      max: 3840
    },
    height: {
      "default": 150,
      min: 64,
      max: 2160
    }
  },
  components: {
    Header: _StripeChartHeader.StripeChartHeader,
    Element: _StripeChartElement.StripeChartElement,
    Fields: _StripeChartFields.StripeChartFields,
    Thumbnail: _StripeChartThumbnail.StripeChartThumbnail,
    Editable: _EditableStripeChartElement.EditableStripeChartElement
  }
};